export function trimDecimals(num, maxDecimals = 5) {
    const factor = 10 ** maxDecimals;
    return Math.trunc(num * factor) / factor;
}
